class LiveClassTabs {
	static ALL = "All";
	static TODAY = "Today";
	static PREVIOUS = "Previous";
    static UPCOMING = "Upcoming";
}

export { LiveClassTabs };